<template lang="pug">
  yz-card.pa-3(outlined)
    .yz-medium-body-xs.text-neutral-500.mb-2 {{ $t('panel.payment_summary') }}

    // Admin fee row
    .d-flex.justify-space-between.align-center.mb-3(v-if="adminFee")
      .yz-medium-body-sm.text-neutral-700 {{ $t('admin_fee') }}
      .yz-medium-body-sm.text-neutral-700 -{{ adminFee | displayPrice($currency) }}

    // Rejected amount row
    .d-flex.justify-space-between.align-center.mb-3(v-if="rejectedAmount")
      .yz-medium-body-sm.text-neutral-700 {{ $t('panel.rejected_amount_label') }}
      .d-flex.align-center.gap-2
        yz-btn(:label="$t('panel.assigned')" size="sm" outlined, disabled)
        .yz-medium-body-sm.text-neutral-700 -{{ rejectedAmount | displayPrice($currency) }}

    // Received amount row
    .d-flex.justify-space-between.align-center.mb-3
      .yz-heading-9.text-neutral-700 {{ $t('panel.received_amount_label') }}
      .yz-heading-9.text-success-500 {{ receivedAmount | displayPrice($currency) }}

    // Received date row
    .yz-medium-body-sm.text-neutral-700 {{ $t('panel.received_date_label') }}
    .yz-regular-body-sm.text-neutral-700.mt-1 {{ formattedReceivedDate }}
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    adminFee: {
      type: Number,
      default: null
    },
    rejectedAmount: {
      type: Number,
      default: null
    },
    receivedAmount: {
      type: Number,
      default: 0
    },
    receivedDate: {
      type: String,
      default: null
    }
  },
  computed: {
    formattedReceivedDate() {
      if (!this.receivedDate) return 'N/A'
      try {
        const date = DateTime.fromISO(this.receivedDate)
        return date.toFormat('dd MMMM yyyy')
      } catch (error) {
        console.error('Error formatting date:', error)
        return 'N/A'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
